import { createContext, useContext } from 'react';
export const IsAxiosReadyContext = createContext(false);

const useIsAxiosReady = (): boolean => useContext(IsAxiosReadyContext);

export default useIsAxiosReady;
